import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * SegmentedControl, the tertiary-track view switcher.
 *
 * CSS selector: `mobile/molecules.css` `.ds-segmented`, with
 * `.ds-segmented__btn` (+ `--active`) for each segment.
 *
 * Doctrine: a segment switches the view, which is a command, so the active
 * thumb is an ink invert and never an accent fill. Same rule as `<RangePills>`.
 * `aria-pressed` is driven by the same `active` value that picks the class, so
 * the announced state cannot drift from the visual one.
 */
export const SegmentedControl = React.forwardRef(function SegmentedControl(
  { className, ...rest },
  ref,
) {
  return <div ref={ref} className={cn('ds-segmented', className)} {...rest} />;
});

export const SegmentedControlItem = React.forwardRef(function SegmentedControlItem(
  { className, active = false, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-pressed={active}
      className={cn('ds-segmented__btn', active && 'ds-segmented__btn--active', className)}
      {...rest}
    />
  );
});

export default SegmentedControl;
